import { render, staticRenderFns } from "./dialogEndorseTimeHint.vue?vue&type=template&id=99ad15c4&scoped=true&"
import script from "./dialogEndorseTimeHint.vue?vue&type=script&lang=js&"
export * from "./dialogEndorseTimeHint.vue?vue&type=script&lang=js&"
import style0 from "./dialogEndorseTimeHint.vue?vue&type=style&index=0&id=99ad15c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99ad15c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('99ad15c4')) {
      api.createRecord('99ad15c4', component.options)
    } else {
      api.reload('99ad15c4', component.options)
    }
    module.hot.accept("./dialogEndorseTimeHint.vue?vue&type=template&id=99ad15c4&scoped=true&", function () {
      api.rerender('99ad15c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insuranceCenter/components/other/dialogEndorseTimeHint.vue"
export default component.exports